import axios from 'axios';
import Resource from './Resource'

export default class Training extends Resource {
  static ENDPOINT = '/api/training'

  constructor (args) {
    super()
    this.extend(args)
  }

  static async recruit (query) {
    const { data } = await axios.get(this.ENDPOINT + '/recruit', { params: query });
    return data.map(d => new this(d));
  }

  static async cardList (query) {
    const { data } = await axios.get(this.ENDPOINT + '/cardlist', { params: query });
    return data.map(d => new this(d));
  }

  static async copy (_id, newTitle) {
    const { data } = await axios.post(this.ENDPOINT + '/copy', { _id, newTitle });
    return data
  }

  static create (org, name, baseYear) {
    // const ncsTraining = { name: '' }
    // const teacher = { name: '' }
    const status = '모집중'
    return new Training({ org, name, baseYear, status })
  }
}
